<fieldset>
  <legend>
    TypeTravaux
  </legend>
  <app-form-input  [label]="'execution'" [name]="getUid()+'_SepAtt_execution'"
                  [parentForm]="parentForm" [rule]="''" [type]="'text'"
                  [value]="typeTravaux.execution">
  </app-form-input>

  <app-form-input  [label]="'conceptionRealisation'"
                  [name]="getUid()+'_SepAtt_conceptionRealisation'"
                  [parentForm]="parentForm" [rule]="''" [type]="'text'"
                  [value]="typeTravaux.conceptionRealisation">
  </app-form-input>
</fieldset>
